<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner bdColor="rgba(23, 1, 51, 0.9)" size="medium" color="#fff" type="ball-fussion" [fullScreen]="true">
    <p style="color: white"> please wait... </p>
  </ngx-spinner>
</div>
 

<div class="container p-4">
  <div class="row justify-content-center">
    <div class="col-12 col-md-10 col-lg-8">
      <form novalidate (ngSubmit)="OnSubmitMakePayment()" [formGroup]="paymentForm">
        <div class="card py-3 px-4">
          <mat-form-field class="w-100">
            <span matPrefix>
              <mat-icon matPrefix>account_box</mat-icon>
            </span>
            <mat-label>Card Holder Name</mat-label>
            <input type="text" matInput formControlName="name" placeholder="Enter your name">
          </mat-form-field>
 
          <mat-form-field class="w-100">
            <span matPrefix>
              <mat-icon matPrefix>email</mat-icon>
            </span>
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" placeholder="Enter your email">
          </mat-form-field>
 
          <!-- Card Number Input -->
          <div class="col-12 mb-3">
            <div id="card-element" class="w-100 field p-2 border border-secondary rounded">
              <!-- Card input field will be embedded here by Stripe -->
            </div>
            <div id="last-four-digits" class="text-muted mt-2"></div>
          </div>
 
          <button mat-raised-button type="submit" class="btn btn-primary w-100 text-white my-3 btn-pay">
            Pay {{paymentForm.value.amount | currency: currencyAUD : 'symbol'}}
          </button>
        </div>
      </form>
 
      <div class="mt-4 text-center">
        <button type="button" class="btn btn-outline-secondary w-100 shadow-lg fw-bold"
          (click)="back()" [matTooltip]="'Back'" *ngIf="!data">
          <mat-icon>arrow_back</mat-icon> Back
        </button>
      </div>
    </div>
  </div>
</div>